<div
    class="sidenav_container"
    [@onSideNavChange]="sideNavState ? 'open' : 'close'"
>
    <div fxLayout="column" fxLayoutGap="10px" class="container">
        <div class="btn-fixed">
            <div
                fxLayout="row"
                fxLayoutAlign="end center"
                [ngClass]="{
                    'btn-open': sideNavState,
                    'btn-close': !sideNavState
                }"
            >
                <button
                    mat-icon-button
                    (click)="onSinenavToggle()"
                    class="btn-open-menu"
                >
                    <app-mb-icon
                        *ngIf="sideNavState"
                        icon="select-left"
                        style="color: #acb0bc"
                    ></app-mb-icon>
                    <app-mb-icon
                        *ngIf="!sideNavState"
                        icon="select-right"
                        style="color: #acb0bc"
                    ></app-mb-icon>
                </button>
            </div>
            <mat-divider></mat-divider>
        </div>

        <div>
            <div>
                <mat-nav-list>
                    <a
                        mat-list-item
                        *ngFor="let page of pages"
                        [@selectedItemMenuState]="page.state"
                        class="nav-item"
                        style="color: #ffffff"
                        (click)="goTo(page.link)"
                    >
                        <app-mb-icon
                            *ngIf="page.icon"
                            [icon]="page.icon"
                            size="md"
                            svgColor="#fff"
                        ></app-mb-icon>
                        <div
                            [@animateText]="linkText ? 'show' : 'hide'"
                            class="page-title"
                        >
                            {{ page?.name }}
                        </div>
                    </a>
                </mat-nav-list>
            </div>
        </div>
        <span class="spacer"></span>
    </div>
</div>
